/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2024, Zumper
 */

/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { BREAKPOINT_MOBILE } from '@zcode-ui/themes'
import { createLazyLoadableSection } from '@zcode/lazy-loadable-section'
import { ErrorFallback, LoadingFallback } from '@zcode/nr/es/shared/components/Fallback'
import { logger } from '@zcode/utils'
import type { ErrorBoundaryProps } from 'react-error-boundary'

const fallbackStyle = css`
  height: 500px;
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    height: 650px;
  }
`

const onRenderError: ErrorBoundaryProps['onError'] = (error, info) => {
  logger.error('render error for AboutApp lazy loadable section', info, error)
}

const onLoadingError = (error: unknown) => {
  logger.error('loading error for AboutApp lazy loadable section', error)
}

const loadFn = /* #__LOADABLE__ */ async () => await import('./AboutApp')

const handleReload = async () => await AboutAppLazyLoadableSection.reload()

const options = {
  errorFallback: () => (
    <ErrorFallback
      css={fallbackStyle}
      message="Error loading about the app"
      onClickReload={handleReload}
    />
  ),

  loadingFallback: () => <LoadingFallback css={fallbackStyle} name="about the app" />,
  onRenderError,
  onLoadingError,
}

export const AboutAppLazyLoadableSection = createLazyLoadableSection(loadFn, options)
